import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import { colors } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const BRAND_GRADIENT = 'linear-gradient(135deg, #EC1E9C 0%, #9C3BC4 52%, #5B3FE0 100%)'
const WORD_GRADIENT = 'linear-gradient(90deg, #EC1E9C 0%, #9C3BC4 55%, #5B3FE0 100%)'

const MIN_UZUNLUK = 8

function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const navigate = useNavigate()

  const [durum, setDurum] = useState('kontrol')
  const [email, setEmail] = useState('')
  const [sifre, setSifre] = useState('')
  const [tekrar, setTekrar] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!token) {
      setDurum('gecersiz')
      setError('Bağlantı eksik veya hatalı.')
      return
    }
    axios.get(`${API}/admin/password-reset/${encodeURIComponent(token)}`)
      .then(res => { setEmail(res.data.email || ''); setError(''); setDurum('form') })
      .catch(err => {
        setError(err.response?.data?.error || 'Bağlantı geçersiz veya süresi dolmuş.')
        setDurum('gecersiz')
      })
  }, [token])

  const yeterli = sifre.length >= MIN_UZUNLUK && sifre === tekrar

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (sifre.length < MIN_UZUNLUK) return setError(`Şifre en az ${MIN_UZUNLUK} karakter olmalı.`)
    if (sifre !== tekrar) return setError('Şifreler eşleşmiyor.')
    setLoading(true)
    try {
      await axios.post(`${API}/admin/password-reset`, { token, password: sifre })
      setDurum('tamam')
    } catch (err) {
      setError(err.response?.data?.error || 'Şifre güncellenemedi.')
      setLoading(false)
    }
  }

  const inputStyle = {
    width: '100%', padding: '12px 14px', borderRadius: '10px',
    border: `1px solid ${colors.border}`, fontSize: '14px',
    color: colors.textPrimary, outline: 'none', boxSizing: 'border-box',
  }
  const labelStyle = { display: 'block', marginBottom: '7px', fontSize: '13px', fontWeight: 500, color: colors.textPrimary }

  const basliklar = {
    kontrol: ['Bağlantı Kontrol Ediliyor', 'Lütfen bekleyin…'],
    gecersiz: ['Bağlantı Geçersiz', 'Bu şifre sıfırlama bağlantısı kullanılmış veya süresi dolmuş olabilir.'],
    form: ['Yeni Şifre Belirleyin', email ? `${email} hesabı için yeni bir şifre oluşturun.` : 'Hesabınız için yeni bir şifre oluşturun.'],
    tamam: ['Şifreniz Güncellendi', 'Artık yeni şifrenizle oturum açabilirsiniz.'],
  }
  const [baslik, altBaslik] = basliklar[durum]

  return (
    <div className="sx-loginwrap" style={{ minHeight: '100vh', display: 'flex', background: '#fff' }}>
      <style>{`
        .sx-input { transition: border-color .15s, box-shadow .15s; }
        .sx-input:focus { border-color: #9C3BC4; box-shadow: 0 0 0 3px rgba(156,59,196,.15); }
        .sx-btn { transition: filter .15s, box-shadow .15s, transform .05s; }
        .sx-btn:hover:not(:disabled) { filter: brightness(1.06); box-shadow: 0 8px 22px rgba(124,58,237,.32); }
        .sx-btn:active:not(:disabled) { transform: translateY(1px); }
        .sx-mail { transition: background .15s, border-color .15s; }
        .sx-mail:hover { background: rgba(255,255,255,0.24); border-color: rgba(255,255,255,0.42); }
        @media (max-width: 860px) {
          .sx-visual { display: none !important; }
          .sx-formcol {
            flex: 1 1 100% !important;
            justify-content: flex-start !important;
            padding: calc(28px + env(safe-area-inset-top)) 16px calc(28px + env(safe-area-inset-bottom)) !important;
          }
          .sx-loginwrap { min-height: 100dvh !important; }
          .sx-logincard { max-width: min(420px, calc(100vw - 32px)) !important; margin: auto !important; }
          .sx-loginhead { margin-bottom: 32px !important; }
          .sx-loginfoot { margin-top: 28px !important; }
          .sx-input { min-height: 48px; }
          .sx-btn { min-height: 48px; }
        }
      `}</style>

      <div className="sx-formcol" style={{
        flex: '0 0 46%', display: 'flex', flexDirection: 'column',
        justifyContent: 'center', padding: '48px 6%', minWidth: 0
      }}>
        <div className="sx-logincard" style={{ width: '100%', maxWidth: '380px', margin: '0 auto' }}>
          <div className="sx-loginhead" style={{ display: 'flex', alignItems: 'center', gap: '11px', marginBottom: '52px', flexWrap: 'wrap' }}>
            <img src="/seux-logo.png" alt="SEUX" style={{ height: '30px', width: 'auto', display: 'block' }} />
            <span style={{ fontSize: '22px', fontWeight: 600, color: colors.textPrimary, letterSpacing: '-0.01em' }}>Smart</span>
          </div>

          <h1 style={{ fontSize: '27px', fontWeight: 700, color: colors.textPrimary, margin: '0 0 6px', letterSpacing: '-0.02em' }}>{baslik}</h1>
          <p className="sx-break" style={{ fontSize: '14px', color: colors.textSecondary, margin: '0 0 34px', maxWidth: '100%' }}>{altBaslik}</p>

          {durum === 'form' && (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '18px' }}>
                <label style={labelStyle}>Yeni Şifre</label>
                <input className="sx-input" type="password" value={sifre} autoFocus autoComplete="new-password"
                  onChange={e => setSifre(e.target.value)} placeholder="••••••••" style={inputStyle} />
                <div style={{ fontSize: '12px', color: colors.textMuted, marginTop: '7px' }}>En az {MIN_UZUNLUK} karakter.</div>
              </div>
              <div style={{ marginBottom: '22px' }}>
                <label style={labelStyle}>Yeni Şifre (Tekrar)</label>
                <input className="sx-input" type="password" value={tekrar} autoComplete="new-password"
                  onChange={e => setTekrar(e.target.value)} placeholder="••••••••" style={inputStyle} />
              </div>

              {error && (
                <div style={{ background: colors.dangerLight, color: colors.dangerText, fontSize: '13px', padding: '10px 14px', borderRadius: '10px', marginBottom: '18px', border: '1px solid #FECACA' }}>{error}</div>
              )}

              <button className="sx-btn" type="submit" disabled={loading || !yeterli} style={{
                width: '100%', padding: '13px', background: WORD_GRADIENT,
                color: '#fff', border: 'none', borderRadius: '10px',
                cursor: loading || !yeterli ? 'default' : 'pointer', fontSize: '15px', fontWeight: 600,
                opacity: loading || !yeterli ? 0.7 : 1
              }}>{loading ? 'Kaydediliyor…' : 'Şifreyi Güncelle'}</button>
            </form>
          )}

          {durum === 'gecersiz' && (
            <>
              <div style={{ background: colors.dangerLight, color: colors.dangerText, fontSize: '13px', padding: '10px 14px', borderRadius: '10px', marginBottom: '22px', border: '1px solid #FECACA' }}>{error}</div>
              <p style={{ fontSize: '13px', color: colors.textSecondary, margin: '0 0 22px', lineHeight: 1.6 }}>
                Yeni bir bağlantı için sistem yöneticinizle iletişime geçin.
              </p>
              <button className="sx-btn" type="button" onClick={() => navigate('/login')} style={{
                width: '100%', padding: '13px', background: WORD_GRADIENT, color: '#fff',
                border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '15px', fontWeight: 600
              }}>Giriş Ekranına Dön</button>
            </>
          )}

          {durum === 'tamam' && (
            <>
              <div style={{ background: '#e6f4ea', color: '#137333', fontSize: '13px', padding: '12px 14px', borderRadius: '10px', marginBottom: '22px', border: '1px solid #ceead6' }}>
                Şifreniz başarıyla değiştirildi. Açık oturumlarınız kapatıldı.
              </div>
              <button className="sx-btn" type="button" onClick={() => navigate('/login')} style={{
                width: '100%', padding: '13px', background: WORD_GRADIENT, color: '#fff',
                border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '15px', fontWeight: 600
              }}>Oturum Aç</button>
            </>
          )}

          {durum === 'kontrol' && (
            <div style={{ fontSize: '13px', color: colors.textMuted }}>Bağlantı doğrulanıyor…</div>
          )}

          <p className="sx-loginfoot" style={{ marginTop: '48px', fontSize: '12px', color: colors.textMuted, textAlign: 'center' }}>© 2026 Seux Digital Agency</p>
        </div>
      </div>

      <div className="sx-visual" style={{
        flex: 1, position: 'relative', overflow: 'hidden',
        background: BRAND_GRADIENT,
        display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 8%'
      }}>
        <div style={{ position: 'absolute', top: '-130px', right: '-90px', width: '380px', height: '380px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.18), transparent 70%)' }} />
        <div style={{ position: 'absolute', bottom: '-160px', left: '-110px', width: '440px', height: '440px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(91,63,224,0.45), transparent 70%)' }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '460px' }}>
          <h2 style={{ fontSize: '46px', fontWeight: 800, lineHeight: 1.08, color: '#fff', margin: '0 0 20px', letterSpacing: '-0.03em' }}>Hoş Geldiniz</h2>
          <p style={{ fontSize: '18px', fontWeight: 500, lineHeight: 1.55, color: 'rgba(255,255,255,0.92)', margin: '0 0 34px' }}>
            Dönüşüm odaklı pazarlama modüllerini tek bir ekrandan yönetin
          </p>
          <a href="mailto:info@seux.com.tr" className="sx-mail" style={{
            display: 'inline-flex', alignItems: 'center', gap: '9px', fontSize: '14px', fontWeight: 500,
            color: '#fff', textDecoration: 'none', background: 'rgba(255,255,255,0.14)',
            border: '1px solid rgba(255,255,255,0.28)', padding: '11px 18px', borderRadius: '9999px'
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
            Sistem yöneticisine ulaşmak için tıklayın
          </a>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
